// extracted by mini-css-extract-plugin
export default {"flex":"QZSl25M3XNy0SIyvHdrT"};
    if(module.hot) {
      // 1647894321496
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  